"use strict";

exports.__esModule = true;
exports.formatTimeline = formatTimeline;
exports.getTimelineFieldName = void 0;
exports.getTimelineName = getTimelineName;
var _Utils = require("../../../Utils");
function getTimelineName(timelineType) {
  var nameArray = timelineType.split(/[_-]/);
  return (0, _Utils.capitalizeWords)(nameArray);
}
var getTimelineFieldName = exports.getTimelineFieldName = (0, _Utils.memoize)(function (field) {
  var nameArray = field.split(".");
  var name = nameArray[nameArray.length - 1];
  return (0, _Utils.capitalizeWords)(name.split(/[-_]/));
});
function formatTimeline(timelines) {
  return timelines.map(function (timeline) {
    return Object.assign({}, timeline, {
      label: getTimelineName(timeline.type),
      fieldLabels: timeline.fields.reduce(function (acc, field) {
        if (!acc[field]) {
          acc[field] = getTimelineFieldName(field);
        }
        return acc;
      }, {})
    });
  });
}